export default __webpack_public_path__ + "static/media/menucrossicon.cb41f6c3.svg";